export function DivisionSweepIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 24h32" />
      <path d="M14 18v12" />
      <path d="M22 18v12" />
      <path d="M26 18v12" />
      <path d="M34 18v12" />
      <circle cx="18" cy="16" r="2" />
      <circle cx="30" cy="16" r="2" />
    </svg>
  );
}
